import Swiper, { Autoplay, Navigation, Pagination } from 'swiper';

export default class Testimonials {
  constructor() {
    this.selector = '.b-testimonials';

    this.selectors = {
      slider: '.b-testimonials__slider',
      slidesWrapper: '.b-testimonials__slider-wrapper',
      slides: '.b-testimonials__slide',
    };

    this.nodes = {};
  }

  bootstrap() {
    const blocks = [ ...document.querySelectorAll(this.selector) ];

    if (blocks.length === 0) {
      return;
    }

    blocks.forEach(block => {
      this.getNodes({ block });
      this.initSliders();
    });
  }

  getNodes({ block }) {
    this.nodes = {
      slider: block.querySelector(this.selectors.slider),
      slidesWrapper: block.querySelector(this.selectors.slidesWrapper),
      slides: [ ...block.querySelectorAll(this.selectors.slides) ],
    };
  }

  initSliders() {
    // eslint-disable-next-line no-new
    new Swiper(this.nodes.slider, {
      modules: [ Navigation, Pagination, Autoplay ],
      slidesPerView: 'auto',
      loop: true,
      spaceBetween: 32,
      autoplay: {
        delay: this.nodes.slider.dataset.delay || 5000,
      },
      speed: this.nodes.slider.dataset.speed || 500,
      navigation: {
        nextEl: '.b-testimonials__slider-control--next',
        prevEl: '.b-testimonials__slider-control--prev',
      },
      pagination: {
        el: '.b-testimonials__pagination',
        dynamicBullets: true,
      },
    });
  }
}
